import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  formContent: {
    minHeight: "240px",
  },
});
